<div class="activities-messages__header">
  <div>{{ activities().length }} steps</div>
  @if (showDeleteAction()) {
    <div class="actions-dropdown" [matMenuTriggerFor]="actionsMenu">
      <span>Actions</span>
      <lucide-icon name="chevron-down" [size]="14" />
    </div>
    <mat-menu #actionsMenu="matMenu">
      <button mat-menu-item (click)="deleteThreadClicked.emit()">
        <img src="assets/images/common/delete.svg" alt="delete" class="menu-icon" />
        <span>{{ Label.get('commonActions.chatGptEnterpriseDeleteConversationAction') }}</span>
      </button>
    </mat-menu>
  }
</div>
<div class="separator"></div>
<section class="activities-messages">
  @for (groupedActivity of activitiesGroupedByDate() | keyvalue; track groupedActivity.key) {
    <div class="activities-messages__date-container">
      <div class="activities-messages__date">{{ groupedActivity.key }}</div>
    </div>
    @for (activity of groupedActivity.value; track activity) {
      <div class="activity-message-content">
        @if (!activity.details.userName) {
          <div class="service-avatar__container">
            <img class="service-avatar" [src]="activity.details.logoPath" />
          </div>
        }

        <div class="activity-message__chat-bubble">
          @if (!activity.details.userName) {
            <!-- <svg
              class="activity-message__chat-bubble-triangle"
              xmlns="http://www.w3.org/2000/svg"
              width="6"
              height="10"
              viewBox="0 0 6 10"
              fill="none"
            >
              <path
                d="M1.86913 0.444824H5.99219V8.44482L1.22218 2.10333C0.735829 1.45675 1.13056 0.444824 1.86913 0.444824Z"
                fill="white"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M5.99215 7.66443V9.32422L0.881625 2.48902C0.0329924 1.51917 0.721713 0.00171345 2.01053 0.00171345L5.99215 0.00170898V1.00757L2.01053 1.00171L1.93241 1.00757C1.55399 1.06409 1.36844 1.52759 1.63358 1.83081L5.99215 7.66443Z"
                fill="#E4E3E8"
              />
            </svg> -->
          }
          <app-activity-message
            [id]="activity.details.id"
            [messages]="activity.messages"
            [citedSources]="activity.citedSources"
            [sources]="activity.sources"
            [timestamp]="activity.details.timestamp"
            [relatedFindings]="findingsByActivity()[activity.details.id]"
            (findingsForActivityClicked)="findingsForActivityClicked.emit(activity.details.id)"
            class="activity-message"
            [class.is-user-message]="activity.details.userName"
          />
          @if (activity.details.userName) {
            <!-- <svg
              class="activity-message__chat-bubble-triangle-right"
              xmlns="http://www.w3.org/2000/svg"
              width="6"
              height="10"
              viewBox="0 0 6 10"
              fill="none"
            >
              <path
                d="M1.86913 0.444824H5.99219V8.44482L1.22218 2.10333C0.735829 1.45675 1.13056 0.444824 1.86913 0.444824Z"
                fill="#f3f0f8"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M5.99215 7.66443V9.32422L0.881625 2.48902C0.0329924 1.51917 0.721713 0.00171345 2.01053 0.00171345L5.99215 0.00170898V1.00757L2.01053 1.00171L1.93241 1.00757C1.55399 1.06409 1.36844 1.52759 1.63358 1.83081L5.99215 7.66443Z"
                fill="#E4E3E8"
              />
            </svg> -->
          }
        </div>

        @if (activity.details.userName; as userName) {
          <p-avatar [label]="userName[0]" shape="circle" class="avatar" [style]="userName | avatarStyle" />
        }
      </div>
    }
  }
</section>
